import React, { FC } from 'react';
import { FlexDynamic, FlexRow, TextDynamic } from '@minecraft.atoms';
import Icon from '@minecraft.icon';
import { useTranslation } from '@blocs.i18n';
import { PlanType } from '../usePlans';
import { priceFormatter } from '../helpers/priceFormatter';
import { PlanCode } from '../enums/plans';

type UnlimitedMediaUpsellProps = {
  show?: boolean;
  plans: PlanType[];
  countryCode: string;
  currencyCode: string;
};

export const UnlimitedMediaUpsell: FC<UnlimitedMediaUpsellProps> = React.memo(
  ({ show, plans, countryCode, currencyCode }) => {
    const { t } = useTranslation();
    const premiumPlan = plans?.find((plan) => plan.code === PlanCode.Premium);

    const price = priceFormatter({
      price: Number(premiumPlan?.strikeThroughPrice || premiumPlan?.price),
      t,
      countryCode,
      currencyCode,
    });

    if (!show) return null;
    return (
      <FlexRow mt="2" mb="5" justifyContent="center" alignItems="center" gap="1" w="full" wrap="nowrap">
        <Icon name="rocket-outline" size="xl" />
        <FlexDynamic mx="3" mdProps={{ mx: '0' }}>
          <TextDynamic
            as="h3"
            fontSize="h3"
            fontWeight="medium"
            lineHeight="default"
            color="default"
            mdProps={{ fontSize: 'h2' }}
          >
            {t('common:paywall.purchaseMedia.premium_m2m', { price })}
          </TextDynamic>
        </FlexDynamic>
      </FlexRow>
    );
  }
);
